import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function StatusError({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 16 16"
    >
      <Path
        d="M8 2C4.688 2 2 4.688 2 8C2 11.312 4.688 14 8 14C11.312 14 14 11.312 14 8C14 4.688 11.312 2 8 2ZM8 8.60004C7.67 8.60004 7.4 8.33004 7.4 8.00004V5.60004C7.4 5.27004 7.67 5.00004 8 5.00004C8.33 5.00004 8.6 5.27004 8.6 5.60004V8.00004C8.6 8.33004 8.33 8.60004 8 8.60004ZM8.6 11H7.4V9.79996H8.6V11Z"
        fill={iconColor}
      />
    </Svg>
  );
}
